import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import { resetPassword, getUserDetailsById } from "../../services/authServices";
import { useModal } from "../../context/ModalContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../context/ToastContext";
import Loading from "../../components/Loading";

function ChangeManagerPassword() {
  const query = new URLSearchParams(useLocation().search);
  const userId = parseInt(query.get("user")) || 0;
  const navigate = useNavigate();
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    username: JSON.parse(localStorage.getItem("userDetails")).username || "",
    refreshToken: localStorage.getItem("refreshToken") || "",
    customPassword: "",
    confirmPassword: "",
  });

  const { showModal } = useModal();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleGoBack = () => {
    navigate(-1); // 3. Go back one step in history
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.customPassword !== form.confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        username: form.username,
        refreshToken: form.refreshToken,
        customPassword: form.customPassword,
      };
      var res = await resetPassword(payload);
      if (res && res.success === false) {
        throw new Error(res.message || "Password update failed.");
      }
      toast.success("Password updated successfully!");
      setLoading(false);
      // showModal("Password Updated", "Password updated successfully.");
      // await api.put("/api/account/reset-password", {
      //   username: form.username,
      //   refreshToken: form.refreshToken,
      //   customPassword: form.customPassword,
      // });
      setTimeout(() => {
        handleGoBack();
      }, 500);
      // alert("Password reset successful");
    } catch (error) {
      setLoading(false);
      //alert(error.response?.data?.message || "Failed to reset password");
      // showModal(
      //   "Password Reset Failed",
      //   error.response?.data?.message || "Failed to reset password"
      // );
      toast.error(error.response?.data?.message || "Failed to reset password");
    }
  };

  const getUserDetails = async () => {
    try {
      if (userId) {
        var response = await getUserDetailsById(userId);
        if (response.id) {
          setForm({ ...form, username: response.username });
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    setTimeout(() => {
      getUserDetails();
    }, 1000);
    // fetchStats(); // Uncomment when API is ready
  }, []);

  return (
    <div className="container py-8 px-[5rem] bg-[#fbfbfb]">
      <Header title={"Settings"} date="Sunday, 22 Dec 2024" />
      <h2 className="text-lg font-semibold mb-4 text-[#585858]">
        Change Password
      </h2>

      <div className="flex flex-row justify-between pt-8 pb-10 px-8 rounded-2xl outline-2 outline-gray-200 text-[#585858] bg-white">
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-2 gap-x-8">
            {/* <label className="w-full">
                Username (Email)
                <input
                  type="email"
                  name="username"
                  value={form.username}
                  onChange={handleChange}
                  placeholder="Enter Email"
                  className="w-full border-2 border-gray-200 px-5 py-3 rounded-lg mt-2 mb-4"
                  required
                />
              </label> */}
            <label className="w-full">
              Enter New Password
              <input
                type="password"
                name="customPassword"
                value={form.customPassword}
                onChange={handleChange}
                placeholder="Enter New Password"
                className="w-full border-2 border-gray-200 px-5 py-3 rounded-lg mt-2 mb-4"
                required
              />
            </label>
            <label className="w-full">
              Confirm New Password
              <input
                type="password"
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                placeholder="Confirm New Password"
                className="w-full border-2 border-gray-200 px-5 py-3 rounded-lg mt-2"
                required
              />
            </label>
          </div>
          <div className="">
            <button
              className="mx-2 bg-gray-300 text-white px-7 py-3 text-md rounded-lg cursor-pointer"
              type="button"
              onClick={handleGoBack}
            >
              Back
            </button>
            <button
              className="mx-2 bg-[#6f81f5] text-white px-7 py-3 text-md rounded-lg cursor-pointer"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <Loading
                  fullscreen={false}
                  loaderColor="white"
                  message=""
                  size="sm"
                />
              ) : (
                "Submit →"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChangeManagerPassword;
